import { render, staticRenderFns } from "./AuthorityView.vue?vue&type=template&id=1509603c&scoped=true"
import script from "./AuthorityView.vue?vue&type=script&lang=js"
export * from "./AuthorityView.vue?vue&type=script&lang=js"
import style0 from "./AuthorityView.vue?vue&type=style&index=0&id=1509603c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1509603c",
  null
  
)

export default component.exports